import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import HeadingLarge from "./HeadingLarge";
import Image from "./Image";
import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";

function Why({ heading, text, image }) {
  return (
    <Box bg="grey" py={[15, null, 45, null]}>
      <BoxWithGutter
        display="flex"
        flexDirection={["column", null, "row", null]}
        height={[null, null, 760, null]}
      >
        <Box width={["100%", null, "50%", null]} py={[50, null, 0, null]}>
          <Box
            height="100%"
            display="flex"
            justifyContent="center"
            flexDirection="column"
            pl={[20, null, null, 130]}
            pr={[20, null, 40, null]}
          >
            <HeadingLarge uppercase fontWeight={700}>
              {heading}
            </HeadingLarge>
            <Text
              pt={[40, null, 60, null]}
              fontSize={[16, 16, 22, 22]}
              lineHeight={["26px", "26px", "32px", "32px"]}
            >
              {text}
            </Text>
          </Box>
        </Box>
        <Box
          width={["100%", null, "50%", null]}
          position="relative"
          height={[0, null, "initial", null]}
          pb={["100%", null, 0, null]}
        >
          {image && (
            <Image
              src={image.src}
              alt={image.alt}
              objectFit="contain"
              height="100%"
              width="100%"
              maxHeight={800}
              maxWidth={800}
            />
          )}
        </Box>
      </BoxWithGutter>
    </Box>
  );
}

export default Why;

Why.propTypes = {
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }),
};
